const MIME_BY_EXTENSION: Record<string, string> = {
  mp3: 'audio/mpeg',
  m4a: 'audio/mp4',
  aac: 'audio/aac',
  flac: 'audio/flac',
  ogg: 'audio/ogg',
  wav: 'audio/wav',
  webm: 'audio/webm',
}

const ALLOWED_CONTENT_TYPES = new Set([
  'audio/mpeg',
  'audio/mp3',
  'audio/mp4',
  'audio/x-m4a',
  'audio/aac',
  'audio/flac',
  'audio/x-flac',
  'audio/ogg',
  'audio/wav',
  'audio/x-wav',
  'audio/webm',
  'application/ogg',
])

export const DEFAULT_MAX_AUDIO_BYTES = 500 * 1024 * 1024

function extensionOf(name: string): string {
  const normalized = name.trim().toLowerCase()
  const index = normalized.lastIndexOf('.')
  return index < 0 ? '' : normalized.slice(index + 1)
}

export function normalizedAudioContentType(file: Pick<File, 'name' | 'type'>): string {
  const extension = extensionOf(file.name)
  const contentType = file.type.trim().toLowerCase()
  return contentType || MIME_BY_EXTENSION[extension] || 'application/octet-stream'
}

export function shouldRefreshCanonicalAudioAfterUpload(file: Pick<File, 'name'>): boolean {
  // M4A is a container and may carry AAC or Apple Lossless (ALAC). The media
  // service can normalize ALAC to AAC, so M4A must re-fetch the canonical
  // server representation before authoring/cache use.
  return extensionOf(file.name) === 'm4a'
}

export function audioUploadError(file: Pick<File, 'name' | 'type' | 'size'>, maxBytes = DEFAULT_MAX_AUDIO_BYTES): string | null {
  const extension = extensionOf(file.name)
  const inferredType = MIME_BY_EXTENSION[extension]
  const contentType = normalizedAudioContentType(file)

  if (!inferredType || !ALLOWED_CONTENT_TYPES.has(contentType)) {
    return 'MP3, M4A, AAC, FLAC, OGG, WAV, WEBM 음원만 업로드할 수 있습니다.'
  }
  if (file.size <= 0) return '비어 있는 음원 파일은 업로드할 수 없습니다.'
  if (file.size > maxBytes) return `음원 파일은 ${Math.floor(maxBytes / 1024 / 1024)}MB 이하만 업로드할 수 있습니다.`
  return null
}
